





















import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppOrderItemList from '@/components/AppOrderItemList.vue'
import OrderItem from '@/components/OrderItem.vue'
import { OrderMixin } from '@/mixins'

@Component({
  components: {
    AppOrderItemList,
    OrderItem
  }
})
export default class extends Mixins(OrderMixin) {
  @Prop() readonly orderDelivery!: object
  @Prop() readonly order!: object
  @Prop() readonly cancelType!: string
  @Prop() readonly orderItemSelected!: { [key: string]: string }

  get selectedOrderItemCount () {
    return Object.keys(this.orderItemSelected).filter(id => this.orderItemSelected[id]).length
  }
}
